// components
import { Typography } from '@centria-ui/components/atoms/typography'

// prime components
import { InputText } from 'primereact/inputtext'

// styles
import classes from './styles.module.scss'

// types
import type { InputsEnum, variantsEnum } from '@centria-ui/commons/enums'
import type { InputTextProps } from 'primereact/inputtext'
import type { FC } from 'react'

export interface InputProps extends InputTextProps {
  label?: string
  showIcon?: boolean
  inputVariant?: keyof typeof InputsEnum
  inputColor?: typeof variantsEnum.light | typeof variantsEnum.white
}

export const Input: FC<InputProps> = ({
  label,
  showIcon,
  className = '',
  inputColor = 'light',
  inputVariant = 'block',
  ...props
}) => (
  <div className='w-100' data-cy='input'>
    {label && (
      <Typography
        Tag='label'
        fontSize='small'
        className='mb-1'
        htmlFor={props.id}>
        {label}
      </Typography>
    )}
    <InputText
      {...props}
      className={`${className} ${classes.input} ${
        classes[`input_${inputVariant}`]
      } ${classes[`input_${inputColor}`]} ${showIcon && classes.icon}`}
    />
  </div>
)
